module.exports = __webpack_public_path__ + "static/media/icon_success.bb5e5352.svg";